import SenderSubjectOptionState from '../store/schema/SenderSubjectOptionState';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';

export interface IsMessageListOptionDirtyState {
    optionState: SenderSubjectOptionState;
    userOptions: UserOptionsType;
}

export default select<IsMessageListOptionDirtyState>({
    optionState: () => store,
    userOptions: () => getUserConfiguration().UserOptions,
})(function isMessageListOptionDirty(state?: IsMessageListOptionDirtyState) {
    let savedOptions = state.userOptions;
    let showSenderOnTopInListView = getFallbackValueIfNull(
        state.optionState.showSenderOnTopInListView,
        savedOptions.ShowSenderOnTopInListView
    );

    return showSenderOnTopInListView !== savedOptions.ShowSenderOnTopInListView;
});
